module.exports = __webpack_public_path__ + "img/abalon-logo.1e79a43.svg";